module.exports = __webpack_public_path__ + "static/Teaching-5d42cd9d208e339209188cd4695b005b.jpg";